import "./publications.css"

import React, { useState } from 'react';

// TODO auto-expand and text highlighting on search
export default function PublicationCard({ publication }) {
    const [showAbstract, setShowAbstract] = useState(false);

    return (
        <div className="publication-card">

            <div className="publication-text-listing">
                <h3> {publication.title} </h3>
                <p><i>{publication.publication_venue}</i></p>
                <p>{publication.authors.join(', ')}</p>
                <p>
                    {publication.pdf && (
                    <>
                        <a href={publication.pdf} target="_blank" rel="noreferrer">[pdf]</a>
                    </>
                    )}
                    {publication.abstract && (
                        <>
                            <span style={{ margin: "0 0.5em 0 0.5em" }}>·</span>
                            <button type="button" className="abstract-toggle" aria-expanded={showAbstract} onClick={() => setShowAbstract(!showAbstract)}>[abstract]</button>
                        </>
                    )}
                    {publication.code && (
                        <>
                            <span style={{ margin: "0 0.5em 0 0.5em" }}>·</span>
                            <a href={publication.code} target="_blank" rel="noreferrer">[code]</a>
                        </>
                    )}
                    {publication.policy_brief && (
                        <>
                            <span style={{ margin: "0 0.5em 0 0.5em" }}>·</span>
                            <a href={publication.policy_brief} target="_blank" rel="noreferrer">[policy brief]</a>
                        </>
                    )}
                    {publication.site && (
                        <>
                            <span style={{ margin: "0 0.5em 0 0.5em" }}>·</span>
                            <a href={publication.site} target="_blank" rel="noreferrer">[project page]</a>
                        </>
                    )}
                </p>
                
                {
                    showAbstract && publication.abstract ? 
                        <p className="abstract-paragraph">
                            <strong>Abstract: </strong>{publication.abstract}
                        </p> : <></>
                }
                {publication.press && (
                    <div className="press-links">
                        <strong>Coverage: </strong>
                            {publication.press.map((item, index) => (
                                <React.Fragment key={index}>
                                    {index > 0 && " · "}
                                    <a href={item.url} target="_blank" rel="noreferrer">{item.outlet}</a>
                                </React.Fragment>
                            ))}
                    </div>
                )}
                {publication.comments && (
                    <div className="comments-section">
                        {/* <strong>Comments: </strong> */}
                        <span dangerouslySetInnerHTML={{ __html: publication.comments }} />
                    </div>
                )}
                
                {/* Render the tags with a single fixed color */}
                {publication.tags && publication.tags.length > 0 && (
                    <div className="publication-tags">
                        {publication.tags.map((tag, index) => (
                            <span key={index} className="publication-tag">{tag}</span>
                        ))}
                    </div>
                )}
            </div>

        </div>
    );
};